module.exports = __webpack_public_path__ + "img/lg_ring_y_s_1_0@3x.de132fdd.png";